define('SageDotCom/DataLayer/Events/Forms/formVisible',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FormVisibleEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = 'form_visible'; // overwrite name
    }

    FormVisibleEvent.prototype = Object.create(EventBase.prototype);

    FormVisibleEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {

        var eventDataGA4 = {};
        var form;
        var progressBar;
        var stepNo = 1;
        var isMultistep = false;

        if (scope) {
            form = $(scope).closest('form');

            // need to take into account the different location of progress bars for different types of forms
            if (form.find(".product-trial-form").length > 0) {
                progressBar = $(".product-trial-header .progress-bar-holder");
            }
            else if (form.find(".privacy-rights-request-form").length > 0) {
                progressBar = $(".score-style-box.privacy-rights-request .progress-bar-holder");
            }
            else {
                progressBar = form.siblings(".progress-bar-holder");
            }
            
            isMultistep = progressBar.length > 0 ? true : false;
            stepNo = isMultistep ? parseInt(progressBar.find("li .progress-bar-current .progress-bar-index")[0].textContent) : 1;
        }

        if (!isMultistep || stepNo === 1) {
            // must be a single step form or step 1 of a multistep form, so send form_visible event
            eventDataGA4 = $.extend(eventDataGA4, {
                "event": this.getName(), //event name
                "triggered_by": "sitecore",
                "release_date": "17th October 2024"
            });

        } else {
            // send form_step_N_viewed event
            eventDataGA4 = $.extend(eventDataGA4, {
                "event": "form_step_" + stepNo + "_viewed", //event name
                "triggered_by": "sitecore",
                "release_date": "20th February 2025"
            });
        }

        if (scope) {

            var level5 = form.find('[data-sc-field-name="Level5"]');
            var modal = $(scope).closest(".modal");
           
            eventDataGA4 = $.extend(eventDataGA4, {
                "gate_content_name": level5.length > 0 ? level5[0].defaultValue : "(not set)",
                "form_step": stepNo,
                "total_steps": isMultistep ? progressBar.find("li").length : 1,
                "form_type": isMultistep ? "multistep" : "normal",
                "form_id": form.attr('id'),
                "display_method": modal.length > 0 ? "modal" : "inline"
            });

            if (isMultistep && stepNo > 1) {
                // only add form_elements parameter if it is a form_step_N_viewed event
                var formElems = form.find(".current-section .form-control, .current-section .control-checkbox");
                var allElems = "";

                if (formElems.length > 0) {
                    var comma = "";
                    $(formElems).each(function (index) {
                        if (index > 0) {
                            comma = ", ";
                        }
                        var currentFormElement = $(this);
                        allElems = allElems + comma + currentFormElement.attr("data-sc-field-name");
                    });
                }

                eventDataGA4 = $.extend(eventDataGA4, {
                    "form_elements": allElems
                });
            }
        }
        return eventDataGA4;
    }

    return new FormVisibleEvent();
});
